import type { ComponentType } from 'react';

/** Uma aba que um módulo soma a Minha conta (ADR 0139). */
export interface AccountTab {
  /** Id próprio, em inglês; vai no endereço (`?tab=`). */
  id: string;
  /** Chave de tradução do nome da aba (`<id do módulo>.…`). */
  labelKey: string;
  component: ComponentType;
  /** Sem permissão, a aba aparece para todos. */
  permission?: string;
}

/** As abas da base, sempre primeiro: Perfil abre por padrão. */
export const BASE_ACCOUNT_TABS = [
  { id: 'profile', labelKey: 'account.tabs.profile' },
  { id: 'security', labelKey: 'account.tabs.security' },
] as const;

export type ShownAccountTab = Pick<AccountTab, 'id' | 'labelKey'> & { component?: ComponentType };

/**
 * As abas que a pessoa vê: as da base e as dos módulos que ela pode abrir, na ordem dos módulos.
 * Uma aba com id repetido fica de fora, para nenhum módulo esconder Perfil ou Segurança.
 */
export function accountTabs(
  moduleTabs: readonly AccountTab[],
  can: (permission: string) => boolean,
): ShownAccountTab[] {
  const shown: ShownAccountTab[] = [...BASE_ACCOUNT_TABS];
  for (const tab of moduleTabs) {
    if (tab.permission && !can(tab.permission)) continue;
    if (shown.some((s) => s.id === tab.id)) continue;
    shown.push(tab);
  }
  return shown;
}
